import React from "react";
import { graphql, useMutation } from "react-relay";
import { useIntl } from "react-intl";
import { Box } from "arkh";
import { WebModal } from "@/src/TopLevelNavigators/UserLoggedIn/WebModal";
import { WorkspaceProductsSearch } from "../WorkspaceProducts/WorkspaceProductsSearch";
import { UserLoggedInNavigatorScreenProps } from "@/src/TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WorkspaceSignalLinkProductMutation } from "./__generated__/WorkspaceSignalLinkProductMutation.graphql";

export function WorkspaceSignalLinkProduct(
  props: UserLoggedInNavigatorScreenProps<"WorkspaceSignalEditLinkProduct">
) {
  const intl = useIntl();
  const [linkProduct] = useMutation<WorkspaceSignalLinkProductMutation>(graphql`
    mutation WorkspaceSignalLinkProductMutation(
      $productId: ID!
      $signalWorkspaceId: ID!
    ) {
      signalWorkspace(id: $signalWorkspaceId) {
        linkProduct(productId: $productId) {
          id
        }
      }
    }
  `);

  return (
    <WebModal
      color="transparent"
      shadow={false}
      dismissable
      contentStyle={{
        width: 600,
        maxHeight: 400,
      }}
    >
      <Box
        style={{
          overflow: "hidden",
          maxHeight: 400,
        }}
        cornerRadius="large"
      >
        <WorkspaceProductsSearch
          isSearching
          onPressProduct={(id) => {
            linkProduct({
              variables: {
                productId: id,
                signalWorkspaceId: props.route.params.signalWorkspaceId,
              },
              onCompleted: () => {
                props.navigation.goBack();
              },
            });
          }}
          productIsDisabled={(id) => {
            return props.route.params.linkedProductIds.includes(id)
              ? intl.formatMessage({
                  defaultMessage: "Product is already linked",
                  description: "LinkProductComponent disabled product reason",
                })
              : undefined;
          }}
          workspaceId={props.route.params.workspaceId}
          autoFocus
          showCancel
          onBlur={props.navigation.goBack}
        />
      </Box>
    </WebModal>
  );
}
